module.exports = {"data":[{"bannerId":1,"courseName":"人像修图入门课","courseId":1,"bannerUrl":"http://49.234.26.179:8000/upload/banner/ban1.png"},{"bannerId":2,"courseName":"Excel 基础入门","courseId":2,"bannerUrl":"http://49.234.26.179:8000/upload/banner/ban2.png"},{"bannerId":3,"courseName":"Python基础趣讲精炼","courseId":3,"bannerUrl":"http://49.234.26.179:8000/upload/banner/ban3.png"},{"bannerId":4,"courseName":"证券投资入门：组合决策与管理","courseId":4,"bannerUrl":"http://49.234.26.179:8000/upload/banner/ban1.png"}]}


//////////////////
// WEBPACK FOOTER
// ./static/json/banner.json
// module id = uAUW
// module chunks = 35